module.exports = __webpack_public_path__ + "img/atletico-madrid.88410b53.png";